import React from 'react';
import { useTestPlaybookDrawerContext } from 'app/playbook-editor/transform-drawer/TestPlaybookDrawerContextProvider';
import SendEventModalLauncher from 'app/shared/components/testing-suite/SendEventModalLauncher';
import ServerResponseOutput from 'app/shared/components/testing-suite/ServerResponseOutput';
import { useTrackPage } from 'api';

export default function ServerResponseTab() {
  useTrackPage('editor_test_server_response_tab_viewed');

  const { integrationName, clusterName, chainState } = useTestPlaybookDrawerContext();
  const { sendEventConfirmed, onConfirmSendEvent, loading, data } = chainState.serverResponse;

  if (!sendEventConfirmed) {
    return (
      <SendEventModalLauncher
        onConfirm={onConfirmSendEvent}
        integrationName={integrationName}
        clusterName={clusterName}
      />
    );
  }

  return (
    <ServerResponseOutput loading={loading} data={data} trackingEventName="editor_test_server_response_output_viewed" />
  );
}
